import React, { useEffect } from 'react'
import type { PublicRequestOccasion } from 'apollo-gql'

import Occasion from 'components/ProductPage/shared/Occasion/Occasion'

import styles from './OccasionsList.module.css'

type OccasionsListProps = {
  onChange?: (value: string) => void
  occasions: PublicRequestOccasion[]
  value?: string
  setSelectedRequestOccasionId: React.Dispatch<React.SetStateAction<string>>
}

const OccasionsList = ({
  onChange = () => null,
  occasions,
  value,
  setSelectedRequestOccasionId,
}: OccasionsListProps): JSX.Element => {
  useEffect(() => {
    if (value) {
      setSelectedRequestOccasionId(value)
    }
    if (!value && occasions?.[0]?.id) {
      onChange(occasions[0].id)
    }
  }, [setSelectedRequestOccasionId, value, occasions, onChange])

  return (
    <div className={styles.wrapper} data-cy="occasionsList">
      {occasions.map((occasion) => {
        if (!occasion) {
          return null
        }
        return (
          <Occasion
            key={occasion.id}
            occasion={occasion}
            isSelected={value === occasion.id}
            onChange={onChange}
          />
        )
      })}
    </div>
  )
}

export default OccasionsList
